import { useIsLoggedIn } from 'services/api/account/hooks/useIsLoggedIn';
import { isAccessTokenSet } from 'utils/authentication';

export type AuthenticationStatus = 'loading' | 'authenticated' | 'anonymous';

/**
 * Whether the current visitor is logged in, for render-time decisions.
 *
 * Trusts the `frontend_user_token` cookie when present; otherwise asks the legacy app, because that
 * cookie can be missing while the session is valid. Treat `'loading'` as undecided, never as anonymous.
 */
export const useIsAuthenticated = (): AuthenticationStatus => {
  const hasUserCookie = isAccessTokenSet();
  const { isLoggedIn, isLoading } = useIsLoggedIn({ enabled: !hasUserCookie });

  if (hasUserCookie || isLoggedIn) return 'authenticated';
  if (isLoading) return 'loading';
  return 'anonymous';
};
